<template>
  <div class="realInfo">
    <!-- 背景图片 -->
    <div class="header">
      <div class="header-content">
        <div class="header-all">
          <img :src="touxiang" width="60px" height="60px" alt="" />
          <div class="user-phone">
            <div>{{ `${userPhone.slice(0, 3)}****${userPhone.slice(7)}` }}</div>
            <div class="noTrue" v-if="noTrueFlog">
              <img :src="weishiming" alt="" />
            </div>
            <div class="yesTrue" v-if="trueFlog">
              <img :src="yishiming" alt="" />
            </div>
          </div>
        </div>
        <div class="my" @click="checkUserDetail">
          <p>我的信息</p>
          <i
            class="iconfont iconyoujiantou"
            style="font-size: 20px; color: #fff"
          ></i>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content-box" @click="toAppla">
        <span>申请中</span>
        <p>{{applying}}</p>
      </div>
      <!-- <div class="content-box">
        <span>待面试</span>
        <p>{{toBeInterviewed}}</p>
      </div> -->
      <div class="content-box" @click="toAdmit">
        <span>已录取</span>
        <p>{{admitted}}</p>
      </div>
      <div class="content-box" @click="toMysign">
        <span>待签约</span>
        <p>{{notSigned}}</p>
      </div>
    </div>
    <div class="update-flex" @click="goMyWallet">
      <div class="money">
        <img
          src="../../assets/img/real/qianbao.png"
          width="23px"
          height="22px"
          alt=""
        />
        <p>我的钱包</p>
      </div>
      <div class="mail">
        <p>电子账户、银行卡</p>
        <i
          class="iconfont iconyoujiantou"
          style="font-size: 20px; color: #999999"
        ></i>
      </div>
    </div>
    <div class="update-block">
      <div class="update-flex1" @click="goWorkOrder">
        <div class="money">
          <img
            src="../../assets/img/real/myWorkOrder.png"
            width="23px"
            height="22px"
            alt=""
          />
          <p>我的工单</p>
        </div>
        <div class="mail">
          <p></p>
          <i
            class="iconfont iconyoujiantou"
            style="font-size:20px;color:#999999"
          ></i>
        </div>
      </div>
      <div class="update-flex1" @click="toMysign">
        <div class="money">
          <img
            src="../../assets/img/real/mySign.png"
            width="23px"
            height="22px"
            alt=""
          />
          <p>我的签约</p>
        </div>
        <div class="mail">
          <p></p>
          <i
            class="iconfont iconyoujiantou"
            style="font-size: 20px; color: #999999"
          ></i>
        </div>
      </div>
      <div class="update-flex1 flex11" @click="goSettle">
        <div class="money">
          <img
            src="../../assets/img/real/mySettle.png"
            width="23px"
            height="22px"
            alt=""
          />
          <p>我的结算</p>
        </div>
        <div class="mail">
          <p></p>
          <i
            class="iconfont iconyoujiantou"
            style="font-size:20px;color:#999999"
          ></i>
        </div>
      </div>
    </div>
    <!-- <div class="update-block block1"> -->
      <!-- <div class="update-flex1">
        <div class="money">
          <img
            src="../../assets/img/real/accountSet.png"
            width="23px"
            height="22px"
            alt=""
          />
          <p>账户设置</p>
        </div>
        <div class="mail">
          <p></p>
          <i
            class="iconfont iconyoujiantou"
            style="font-size:20px;color:#999999"
          ></i>
        </div>
      </div> -->
      <!-- <div class="update-flex1 flex11">
        <div class="money">
          <img
            src="../../assets/img/real/guanyuwomen.png"
            width="23px"
            height="22px"
            alt=""
          />
          <p>关于我们</p>
        </div>
        <div class="mail">
          <p></p>
          <i
            class="iconfont iconyoujiantou"
            style="font-size: 20px; color: #999999"
          ></i>
        </div>
      </div> -->
    <!-- </div> -->
    <!-- <div class="footer">
      <div class="footer-bottom bottom1">
        <img
          src="../../assets/img/real/myIndex.png"
          width="22px"
          height="22px"
          alt=""
        />
        <p>首页</p>
      </div>
      <div class="footer-bottom">
        <img
          src="../../assets/img/real/release.png"
          width="22px"
          height="22px"
          alt=""
        />
        <p>发布任务</p>
      </div>
      <div class="footer-bottom bottom3">
        <img
          src="../../assets/img/real/mine.png"
          width="22px"
          height="22px"
          alt=""
        />
        <p>我的</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config";
export default {
  data() {
    return {
      userPhone: "",
      trueFlog: false,
      noTrueFlog: false,
      touxiang: require("../../assets/img/real/touxiang.png"),
      weishiming: require("../../assets/img/real/weishiming.png"),
      yishiming: require("../../assets/img/real/yishiming.png"),
      admitted:"",
      applying:"",
      notSigned:"",
      toBeInterviewed:"",
    };
  },

  mounted() {
    this.fetchHomeInfo();
    this.userStatInfo()
    this.userPhone = sessionStorage.getItem("user_mobile");
  },

  methods: {
    fetchHomeInfo() {
      http.post(config.h5UserHomeInfo).then(({ code, data, message }) => {
        if (code === 0) {
          if (data.code === 201) {
            this.noTrueFlog = true;
          } else {
            this.trueFlog = true;
          }
        } else {
          this.$toast.fail(message);
          this.$router.push({path:"/noLogin"})
        }
      });
    },
    // 我的信息详情
    checkUserDetail() {
      if (this.noTrueFlog) {
        this.$router.push({ path: "/register" });
      } else {
        this.$router.push({ path: "/myReal" });
      }
    },
    // 我的钱包
    goMyWallet() {
      if (this.noTrueFlog) {
        this.$router.push({ path: "/register" });
      } else {
        http.post(config.myWallet).then(({ code, data, message }) => {
          if (code === 0) {
            if (data.code === 201) {
              // more为0，更多操作隐藏掉
              // this.$router.push({ path: "/register",query:{more:0} });
              this.$toast.success("您已实名");
            } else {
              this.$router.push({ path: "/myWallet" });
            }
          } else {
            this.$toast.fail(message);
          }
        });
      }
    },
    // 数据统计
    userStatInfo(){
      http.post(config.userStatInfo).then(({code,data,message})=>{
        if(code===0){
          this.admitted=data.personStat.admitted;
          this.applying=data.personStat.applying;
          this.notSigned=data.personStat.notSigned;
          this.toBeInterviewed=data.personStat.toBeInterviewed;

        }else{
          this.$toast.fail(message)

        }
      })
    },
    toMysign() {
      this.$router.push({ path: "/mySign" });
    },
    toAppla(){
      this.$router.push({path:"/applyAdmitTab",query:{flag:1}})
    },
    toAdmit(){
      this.$router.push({path:"/applyAdmitTab",query:{flag:3}})
    },
    goWorkOrder(){
      this.$router.push("/workOrderTab")
    },
    goSettle(){
      this.$router.push("/dealOrderTab")
    }
  },
};
</script>

<style lang="less" scoped>
.realInfo {
  width: 750px;
  height: 100%;
  background-color: #f5f5f5;
  .header {
    background: url("../../assets/img/real/bj.png") no-repeat;
    height: 443px;
    background-size: 100% 100%;
    .header-content {
      padding-top: 137px;
      display: flex;
      justify-content: space-between;

      .header-all {
        margin-left: 30px;
         align-items: center;
        display: flex;
        .user-phone {
          margin-left: 20px;
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          .noTrue {
            text-align: left;
            font-size: 24px;
            img {
              display: inline-block;
              width: 140px;
              height: auto;
            }
          }
          .yesTrue {
            text-align: left;
            font-size: 24px;
            img {
              width: 120px;
              height: auto;
            }
          }
        }
        .user-type {
          font-size: 24px;
        }
      }
      .my {
        padding-right: 30px;
        display: flex;
        align-items: center;
        p {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
  .content {
    height: 170px;
    background: #ffffff;
    box-shadow: 3px 2px 14px 0px rgba(15, 108, 244, 0.14);
    border-radius: 10px;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: -150px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .content-box {
      height: 80px;
      width: 184px;
      text-align: center;
      border-right: 1px solid #ececec;
      span {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        padding-top: -20px;
      }
      p {
        font-size: 42px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 10px;
      }
    }
  }
  .update-flex {
    text-align: left;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 20px;
    height: 100px;
    background: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding-right: 30px;
    padding-left: 10px;
    .money {
      display: flex;
      align-items: center;
      img {
        padding-left: 24px;
        align-items: center;
      }
      p {
        padding-left: 24px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #313131;
      }
    }
    .mail {
      display: flex;
      align-items: center;
    }
    p {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #939393;
    }
  }
  .update-block {
    margin-right: 30px;
    margin-left: 30px;
    background: #ffffff;
    border-radius: 10px;
    margin-top: 20px;
    padding-top: 1px;
    .update-flex1 {
      text-align: left;
      margin-left: 30px;
      margin-right: 30px;
      margin-top: 20px;
      height: 80px;
      background: #fff;
      border-bottom: 1px solid #ececec;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      .money {
        display: flex;
        align-items: center;
        img {
          align-items: center;
        }
        p {
          padding-left: 24px;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #313131;
        }
      }
      .mail {
        display: flex;
        align-items: center;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #939393;
      }
    }
  }
  .update-block .flex11 {
    border: none;
  }
  .footer {
    height: 106px;
    width: 100%;
    background: #ffffff;
    border-radius: 1px;
    position: fixed;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .footer-bottom {
      width: 100px;
      height: 60px;
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top: -3px;
      }
    }
  }
  .footer .bottom1 {
    padding-left: 144px;
  }
  .footer .bottom3 {
    padding-right: 144px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/updateInfo/index.vue